export const MuiToolTip = {
  MuiTooltip: {
    defaultProps: {
      disableInteractive: true,
    },
  },
};
